var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18625_181676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C11.2044 6.5 10.4413 6.81607 9.87868 7.37868C9.31607 7.94129 9 8.70435 9 9.5V21.5C9 22.2956 9.31607 23.0587 9.87868 23.6213C10.4413 24.1839 11.2044 24.5 12 24.5C12.7956 24.5 13.5587 24.1839 14.1213 23.6213C14.6839 23.0587 15 22.2956 15 21.5V9.5C15 8.70435 14.6839 7.94129 14.1213 7.37868C13.5587 6.81607 12.7956 6.5 12 6.5Z",
    fill: "#305F32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0.5C20.2044 0.5 19.4413 0.81607 18.8787 1.37868C18.3161 1.94129 18 2.70435 18 3.5V21.5C18 22.2956 18.3161 23.0587 18.8787 23.6213C19.4413 24.1839 20.2044 24.5 21 24.5C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V3.5C24 2.70435 23.6839 1.94129 23.1213 1.37868C22.5587 0.81607 21.7956 0.5 21 0.5Z",
    fill: "#305F32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5C2.20435 12.5 1.44129 12.8161 0.87868 13.3787C0.31607 13.9413 0 14.7044 0 15.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5C3.79565 24.5 4.55871 24.1839 5.12132 23.6213C5.68393 23.0587 6 22.2956 6 21.5V15.5C6 14.7044 5.68393 13.9413 5.12132 13.3787C4.55871 12.8161 3.79565 12.5 3 12.5Z",
    fill: "#305F32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18625_181676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.f1ea4a895db30735efc92efa0254ea24.svg";
export { ForwardRef as ReactComponent };